import { useMemo } from "react";
import { getCoreRowModel, useReactTable } from "@tanstack/react-table";
import { Show } from "shared/components";
import { Pagination } from "shared/components/Pagination";
import { Table } from "shared/app/Table";
import { Applicant } from "types/application";
import { TransactionsEmptyState } from "../TransactionsEmptyState";
import { getSharedColumns } from "../utils";
import { useConfirmationViewController } from "../controllers/useConfirmationViewController";

type Props = {
  applicationId: number;
  verificationId: number;
  applicant: Applicant;
  incomeId?: number;
  selectionIds: number[];
};

export const ConfirmationView = ({
  applicationId,
  verificationId,
  applicant,
  incomeId,
  selectionIds
}: Props) => {
  const confirmation = useConfirmationViewController({
    applicationId,
    verificationId,
    applicant,
    incomeId,
    selectionIds,
    enabled: selectionIds.length > 0
  });

  const columns = useMemo(() => getSharedColumns(() => false), []);

  const table = useReactTable({
    data: confirmation.items,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getRowId: (row) => String(row.id)
  });

  return (
    <div className="px-6 py-5 flex flex-col gap-3 bg-background-900 flex-1">
      <div className="flex items-center justify-between">
        <p className="text-base text-content-1000 font-medium">
          Selected deposits
        </p>
      </div>

      {confirmation.isEmpty ? (
        <TransactionsEmptyState />
      ) : (
        <Table
          tableClassName=""
          rowHeight="48px"
          thClassName="!px-4 !py-3 [&_.group]:!gap-1 [&_.group_span]:!ml-0 [&_.group_span]:!opacity-100"
          tdClassName="!py-1 !px-4"
          table={table}
          disableMobileListView
          isLoading={confirmation.isLoading}
          sortableKeys={["description", "date", "amount"]}
          sorted={confirmation.sortingState}
          setSorted={confirmation.setSortingState}
        />
      )}
      <Show if={confirmation.totalPages > 1}>
        <Pagination
          className="justify-end"
          total={confirmation.totalPages}
          current={confirmation.page}
          onChange={confirmation.setPage}
        />
      </Show>
    </div>
  );
};
